import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import { getCreateJobRoute } from "../../../routers/routeUtils";

import { CreateJobIcon } from "../assets/icons/go-hire-page-icons";

const GoHireHeader = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "goHirePage" });

  const navigate = useNavigate();
  const handleCreateJob = () => navigate(getCreateJobRoute());

  return (
    <Box sx={styles.container} component="header">
      <Box sx={styles.headerText}>
        <Typography sx={styles.headerTextTitle}>{t("gettingStartedWithJobs")}</Typography>
        <Typography sx={styles.headerTextSubtitle}>{t("discoverRecruitTalentsGlobally")}</Typography>
      </Box>
      <Button variant="primary-md" startIcon={<CreateJobIcon />} sx={styles.createJobButton} onClick={handleCreateJob}>
        <Typography>{t("createJob")}</Typography>
      </Button>
    </Box>
  );
};

export default GoHireHeader;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: "24px", sm: "0" },
  },
  headerText: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  headerTextTitle: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
  headerTextSubtitle: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  createJobButton: {
    height: "fit-content",
  },
};
